import { render } from "./StaffAuthLayout.vue?vue&type=template&id=f477896e&scoped=true"
import script from "./StaffAuthLayout.vue?vue&type=script&lang=js"
export * from "./StaffAuthLayout.vue?vue&type=script&lang=js"

import "./StaffAuthLayout.vue?vue&type=style&index=0&id=f477896e&scoped=true&lang=scss"

import exportComponent from "/builds/check-marq/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f477896e"]])

export default __exports__